import ResourceService from "./resource.service";

class PromoCodeService extends ResourceService {
  static get resource() {
    return "promo-code";
  }
}

export default PromoCodeService;
